<template>
  <div class="MessageInfo">
    <h3>{{ formVal.title }}</h3>
    <div class="MessageInfo-header">
<!--      <p class="MessageInfo-header-Urgency">-->
<!--        重要程度:<span style="color: red">{{-->
<!--          formVal.receiveLevel == 1 ? "必须处理" : "重要"-->
<!--        }}</span>-->
<!--      </p>-->
      <p class="MessageInfo-header-date">日期：{{ formVal.sendTime }}</p>
    </div>
    <p
      class="MsoNormal"
      style="text-align: left; line-height: 24pt; text-indent: 12pt; margin: 0cm 0cm 18.75pt; mso-pagination: widow-orphan; mso-margin-top-alt: auto;
          mso-char-indent-count: 2.0;"
      align="left"
    >
      <span
        style="font-family: 宋体; color: black; font-size: 12pt; mso-bidi-font-family: 宋体; mso-font-kerning: 0pt;"
      >
        {{ formVal.content }}
      </span>
    </p>
<!--    <div class="MessageInfo-footer">-->
<!--      <a-->
<!--        href="javascript:void(0)"-->
<!--        style="color: #0d50cd"-->
<!--        @click="handleGoRouterView"-->
<!--        >跳转相关页面>>></a-->
<!--      >-->
<!--    </div>-->
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "MessageInfo",
  props: {
    formVal: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {};
  },
  methods: {
    ...mapMutations({
      isactivekey: "IS_ACTIVE_KEY"
    }),
    handleGoRouterView() {
      this.$router.push({ path: this.formVal.msgUrl });
      this.isactivekey(this.formVal.msgUrl);
      // this.$router.push({path:"/enrollModel/ProvinceBatchSubModel"});
      // this.isactivekey("/enrollModel/ProvinceBatchSubModel");
    }
  }
};
</script>

<style scoped lang="less">
.MessageInfo {
  width: 100%;
  h3 {
    text-align: center;
  }
  .MessageInfo-header {
    width: 100%;
    height: 50px;
    padding: 20px;
    .MessageInfo-header-Urgency {
      float: left;
    }
    .MessageInfo-header-date {
      float: right;
    }
  }
  .MessageInfo-footer {
    width: 100%;
    margin-top: 20px;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/MessageInfo.vue